import {useTranslation} from "react-i18next";
import {useState} from "react";
import {Consts} from "../../pages/consts";
import IntakePlan from "./IntakePlan";
import TimingTypeRadioGroup from "./TimingTypeRadioGroup";
import IntakeTypeRadioGroup from "../../drugs/IntakeTypeRadioGroup";
import IntakesFrequencyAndDosageUnit from "./IntakesFrequencyAndDosageUnit";
import useDialogDrag from "../../../hooks/useDialogDrag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Intakes = ({onSaveDrug, selectedDrug, setSelectedDrug, initIntakes, showDialog}) => {
  const {t} = useTranslation();
  const [intakesCompleted, setIntakesCompleted] = useState(false);
  const { dragStyle, isDragging, onDragHandleMouseDown } = useDialogDrag(Boolean(showDialog));

  const dialogTitle = initIntakes
    ? `${t("please_specify_an_intake_plan_for")} ${selectedDrug?.productName || ""}`
    : `${t("your_intake_plan_for")} ${selectedDrug?.productName || ""}`;

  const cleanIntakesAndSaveDrug = () => {
    const cleanedIntakes = selectedDrug?.intakes?.filter(intake =>
      intake?.intakeTime !== "" && !isNaN(intake?.dosage ) && intake?.dosage > 0);

    onSaveDrug({...selectedDrug, intakes: cleanedIntakes});
  };

  const handleSetIntakeType = (intakeTypeObj) => {
    setSelectedDrug({...selectedDrug, ...intakeTypeObj});
  }

  const enableSubmit = selectedDrug?.intakeType === Consts.ON_DEMAND
    || (
      selectedDrug?.timingType !== ""
      && initIntakes
      && selectedDrug?.dosageUnit && selectedDrug?.dosageUnit?.dosageUnit !== ""
      && intakesCompleted
    );

  return (
    <div
      className="w3-modal intakes-dialog-modal"
      style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }
    >
      <div
        className={ `w3-modal-content w3-card-4 w3-animate-zoom form-panel intakes-dialog dialog-draggable ${isDragging ? "dialog-draggable--dragging" : ""} ${
          initIntakes ? "dialog-medium" : "dialog-narrow"
        }` }
        style={dragStyle}
      >
        <header className="dialog-drag-header" onMouseDown={onDragHandleMouseDown}>
          <strong className="dialog-drag-header__title">{dialogTitle}</strong>
          <button
            type="button"
            className="dialog-drag-close"
            onClick={ () => showDialog(false) }
            aria-label={t("close", { defaultValue: "Close" })}
            title={t("close", { defaultValue: "Close" })}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>
        { initIntakes ? (
          <>
            <div className="w3-container intakes-dialog__body">
              <IntakeTypeRadioGroup onSetIntakeType={ handleSetIntakeType }/>
              { selectedDrug?.intakeType === Consts.REGULARLY && (
                <>
                  <IntakesFrequencyAndDosageUnit
                    selectedDrug={ selectedDrug }
                    setSelectedDrug={ setSelectedDrug }
                  />
                  <TimingTypeRadioGroup
                    selectedDrug={ selectedDrug }
                    setSelectedDrug={ setSelectedDrug }
                    setIntakesCompleted={ setIntakesCompleted }
                  />
                </>
              ) }
            </div>
          </>
        ) : (
          <div className="intakes-dialog__body w3-margin-bottom">
            <IntakePlan selectedDrug={ selectedDrug } showHeader={ false }/>
          </div>
        ) }
        { initIntakes && (
          <footer className="w3-container w3-padding-small intakes-dialog__footer">
            <div className="intakes-dialog__actions">
              <button
                className="w3-btn w3-round-xlarge w3-theme-d5 intakes-dialog__button"
                onClick={ cleanIntakesAndSaveDrug }
                disabled={ !enableSubmit }
              >
                { t("submit") }
              </button>
            </div>
          </footer>
        )}
      </div>
    </div>
  );
};

export default Intakes;
